var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconToastMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.794,
    height: 12.594,
    viewBox: "0 0 12.794 12.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-check-circle",
    "data-name": "Icon feather-check-circle",
    transform: "translate(-2.25 0.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13892",
    "data-name": "Path 13892",
    d: "M14.2,8.077v.515a5.6,5.6,0,1,1-3.32-5.117",
    transform: "translate(0 -2.991)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13893",
    "data-name": "Path 13893",
    d: "M20.778,6l-5.6,5.6L13.5,9.924",
    transform: "translate(-6.581 -4.877)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToastMessage);
export default __webpack_public_path__ + "static/media/icon-toastMessage.6d93c7946b99b1893a39c358e857a149.svg";
export { ForwardRef as ReactComponent };